export default "__VITE_ASSET__388ffccf__"